module.exports = __webpack_public_path__ + "static/media/event1.1d43917d.jpg";